import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ModalController } from 'ionic-angular';
import { DIC } from '../../dic';
import * as moment from 'moment'
import { GN } from '../../../gn';
import { AddholidayPage } from './addholiday';
import { HolidayPage } from './holiday';

/**
 * Generated class for the AllholidaysPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-allholidays',
  templateUrl: 'allholidays.html',
})
export class AllholidaysPage {
  gr: any;
  proba: any;
  datumnekoj: any
  companyDays = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public alertCtrl: AlertController, public modalCtrl: ModalController) {
    this.gr = navParams.get('gr')
    this.proba = this.gr
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AllholidaysPage');
    var _that = this
    for (let i = 0; i < _that.gr.length; i++) {
      // _that.gr.datum       
      _that.gr[i].datum1 = moment(_that.gr[i].datum).format('DD-MM-YYYY')
    }
  }

  deleteHoliday(_id, _fnname) {
    // console.log (_id,_fnname,'daj da vidam sto davas')
    var _that = this
    let confirm = this.alertCtrl.create({
      title: _fnname,
      message: this.dic.l["delholiday"],
      buttons: [
        {
          text: this.dic.l["NO"],
          handler: () => {

          }
        },
        {
          text: this.dic.l["YES"],
          handler: () => {
            _that.gn._Post('/api/gn/deleteHoliday', { id: _that.gn.crypt(_id) }, function (_data) {
              for (let i = 0; i < _that.gr.length; i++) {
                if (_that.gr[i].id == _id) {
                  var _cb = _that.navParams.get('cb')
                  _cb(_that.gr[i].datum);
                  //_that.gr.splice(i, 1);
                }
              }
              _that.navCtrl.pop()
            })
          }
        }
      ]
    });
    confirm.present();
  }

  EditCompanyDay(_g) {
    console.log(_g)

    var _that = this
    let modal = this.modalCtrl.create(AddholidayPage, {
      gr: _g, cb1: function (_name) {
        for (var i = 0; i < _that.gr.length; i++) {
          if (_that.gr[i].datum1 == _g.datum1) {
            _that.gr[i].dayname = _name
          }
        }
      }
    });

    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/holiday/allholidays.ts